import { ref, type Ref, computed, type ComputedRef } from 'vue'
import { defineStore } from 'pinia'
import { type WorklogItem, WorklogItemEnum, UserStateEnum, type WorklogDTO } from '@/common/types/case'

export const useCaseWorklogStore = defineStore('caseWorklog', () => {
  const id: Ref<number | null> = ref(null)
  const logs: Ref<Array<WorklogItem>> = ref([])
  const userState: Ref<UserStateEnum | null> = ref(null)
  const initialized = ref(false)

  const init = ({ worklogs, userState: state, userWorklogId }: WorklogDTO) => {
    logs.value = worklogs
    id.value = userWorklogId
    userState.value = state
    initialized.value = true
  }

  const getWorkDuration: ComputedRef<number> = computed(() => {
    const durationTypes = [WorklogItemEnum.CREATE, WorklogItemEnum.HANDLE]
    const durationReducer = (duration: number, log: WorklogItem) => {
      return durationTypes.includes(log.type) ? log.duration + duration : duration
    }
    return logs.value.reduce(durationReducer, 0)
  })

  const isTimerStarted: ComputedRef<boolean> = computed(() => {
    const timerStates = [UserStateEnum.WORKING]
    if (userState.value) return timerStates.includes(userState.value)
    else return false
  })

  return {
    id,
    logs,
    userState,
    getWorkDuration,
    isTimerStarted,
    initialized,
    init,
  }
})
